<!--
* @FileDescription: 管理后台顶部
* @Author: Rocky
* @Date: 2020-12-25
* @LastEditors: Rocky
* @LastEditTime: 2025-10-15
-->
<template>
  <div id="app-header">
    <el-row>
      <el-col class="app-logo" :span="4">
        <ul style="padding: 0%;margin: 10px 0px;">
          <li>
            <span style="color: #fff; font-size: 24px;">新民市跨境进口供应链平台</span>
            <br/>
            <span style="color: #fff; font-size: 12px;">Xinmin City Cross-border Import Supply Chain Platform</span>
          </li>
        </ul>
      </el-col>
      <el-col class="app-links" :span="16">
        <ul>
          <li v-for="(item, index) in assets.appLinks" :key="index"
          @click="goMain(index)">
            <i :class="item.icon"></i>
            <span>{{ item.text }}</span>
            <span>{{ appLinkData[item.id] }}</span>
          </li>
        </ul>
      </el-col>
      <el-col class="app-btns" :span="2" :offset="2">
        <ul>
          <li @click="openEditPassword">
            <i class="el-icon-lock"></i>
            <span>修改密码</span>
          </li>
          <li @click="logout">
            <i class="el-icon-switch-button"></i>
            <span>退出</span>
          </li>
        </ul>
      </el-col>
    </el-row>

    <!-- 对话框 -->
    <el-dialog :close-on-click-modal="false" title="修改密码" :visible.sync="showEditPassword" :show-close="true"
    width="30%" :modal="false" top="30vh" custom-class="app-alert-dialog">
      <el-form :model="formData" label-position="left" label-width="80px" :rules="formRules" ref="passwordForm">
        <el-form-item label="原密码" prop="oriPw">
          <!-- type="password" -->
          <el-input size="small" v-model="formData.oriPw" placeholder="请输入原密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPw">
          <el-input size="small" v-model="formData.newPw" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="rePw">
          <el-input size="small" v-model="formData.rePw" placeholder="请再次输入新密码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditPassword = false">取 消</el-button>
        <el-button type="primary" @click="doEditPassword">修 改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const md5 = require('@/../static/plugins/md5.js')

export default {
  name: 'app-header',
  data () {
    // 密码一致性验证函数
    const validatePassword = (rule, value, callback) => {
      if (value !== this.formData.newPw) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    
    // 密码不为空验证
    const validateNotEmpty = (rule, value, callback) => {
      if (!value) {
        callback(new Error('此字段不能为空'))
      } else {
        callback()
      }
    }
    
    return {
      assets: {
        appLinks: [
          // { id: 'member', icon: 'el-icon-user-solid', text: '注册会员', path: '/user' },
          // { id: 'order', icon: 'el-icon-s-order', text: '今日发布', path: '/order' },
          // { id: 'driver', icon: 'el-icon-s-custom', text: '会员', path: '/driver' },
          // { id: 'waiting', icon: 'el-icon-s-cooperation', text: '活跃度', path: '/order' },
          // { id: 'ongoing', icon: 'el-icon-s-promotion', text: '发帖数', path: '/order' }
        ]
      },
      appLinkData: {
        'member': 100,
        'order': 100,
        'driver': 100,
        'waiting': 100,
        'ongoing': 100
      },
      formData: {
        oriPw: '',
        newPw: '',
        rePw: ''
      },
      // 表单验证规则
      formRules: {
        oriPw: [
          { validator: validateNotEmpty, trigger: 'blur' }
        ],
        newPw: [
          { validator: validateNotEmpty, trigger: 'blur' }
        ],
        rePw: [
          { validator: validateNotEmpty, trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ]
      },
      showEditPassword: false
    }
  },
  methods: {
    /**
     * 跳转到 Main 中对应链接
     */
    goMain (index) {
      let that = this
      let linkPath = that.assets.appLinks[index].path
      if (linkPath !== this.$route.path) {
        that.$router.replace({
          path: linkPath,
          params: {}
        })
      }
    },
    /**
     * 打开对话框
     */
    openEditPassword () {
      let that = this
      that.showEditPassword = true
      // 重置表单
      this.$nextTick(() => {
        this.$refs.passwordForm.resetFields()
      })
    },
    doEditPassword () {
      let that = this
      let uid = that.COOKIE.getCookie('uid')
      let username = that.COOKIE.getCookie('username')
      if (undefined === uid || '' === uid || undefined === username || '' === username){
        that.$message.success("管理员登录过期，请重新登录")
        location.reload()
      }
      // 表单验证
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          // 验证通过，执行修改密码操作
          let data = that.formData
          
          that.SERVER.request({
              url: 'admin.php',
              method: 'POST',
              data: {
                controller: 'changePwd',
                data: {
                  uid: uid,
                  username: username,
                  oriPw: md5.hexMD5(data.oriPw),
                  newPw: md5.hexMD5(data.newPw)
                }
              },
              success: function (res) {
                console.log(res)
                if (res.data.status === 200) {
                  that.$message.success("修改成功请重新登录")
                  that.showEditPassword = false
                } else {
                  that.$message.error(res.data.errmsg)
                }
              },
              error: function (errMsg) {
                that.boundErrorMessages(errMsg)
              }
            })
        } else {
          // 验证失败，显示错误提示
          that.$message.error("表单填写有误，请检查后重试！")
          return false
        }
      })
    },
    /**
     * 登出
     */
    logout () {
      this.COOKIE.clearCookie('uid')
      location.reload()
    }
  }
}
</script>

<style scoped>
.app-logo {
  position: relative;
  left: 0px;
  top: -8px;
}
.app-links ul,
.app-btns ul {
  list-style: none;
  padding: 6px;
}
.app-alert-dialog .el-form-item {
    margin-bottom: 15px;
}
.app-btns li,
.app-links li {
  display: inline-block;
  margin-right: 25px;
  cursor: pointer;
}
.app-links li i {
  font-size: 17px;
  color: #494949;
  position: relative;
  top: 1px;
}
.app-links li span:nth-child(2),
.app-btns li {
  color: #a8a8a8;
}
.app-links li span:last-child {
  color: #a8a8a8;
}
.app-links li:hover span:nth-child(2) {
  color: #deefff;
}
.app-links li:hover i,
.app-links li:hover span:last-child {
  color: #deefff;
}
</style>



// WEBPACK FOOTER //
// src/components/frame/Header.vue